// extracted by mini-css-extract-plugin
export default {"ant-table-thead":"typeCodeDrawer_ant-table-thead__4bn0V","button":"typeCodeDrawer_button__zT817","input-flex-area":"typeCodeDrawer_input-flex-area__5584b"};